import { Navigate, useParams } from "react-router-dom"

import { LOGIN_ROUTE, SIGN_IN_WITH_OTP_ROUTE } from "../../../constants/routes"
import { AuthenticationTokenType } from "../../login/loginTypes"

type Props = Readonly<{
    /** Where to land after the auto-login turns the device secret into a device session. */
    targetRoute: string
}>

/**
 * Turns a device-secret link into a device session and opens the target display page. Screen
 * links stay revocable by resetting the device secret, and the page then fetches its data with
 * the device session's merchant.
 */
export function DeviceSecretBridge({ targetRoute }: Props) {
    const { deviceSecret } = useParams<{ deviceSecret: string }>()

    if (!deviceSecret) {
        return <Navigate to={LOGIN_ROUTE} replace />
    }

    const autoLoginUrl = `${SIGN_IN_WITH_OTP_ROUTE}?token=${encodeURIComponent(deviceSecret)}&type=${AuthenticationTokenType.DEVICE_SECRET}`

    return <Navigate to={autoLoginUrl} state={{ originalUrl: targetRoute }} replace />
}
